import React,{useState,useEffect} from 'react';
import {Alert,Button,Select,Table,Upload,message, Switch } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import axios from "axios";
import {cancelTokenSource, useAxios} from "../hooks/hooks";
import {useKeycloak} from "@react-keycloak/web";
import config from "../business/config.json"
import {useNavigate} from "react-router-dom";

const { Dragger } = Upload;
const { Option } = Select;

function CSVComponent(props){
	const axios = useAxios();
	const source = cancelTokenSource;
	const [step,setStep] = useState(0);
	const [original,setOriginal] = useState("");
	const [parsed,setParsed] = useState(null);
	const navigate = useNavigate();
	const [template,setTemplate] = useState(true);
	const [newTemplate, setNewTemplate] = useState(true);
	const [datasource,setDatasource] = useState(null);
	const [columns,setColumns] = useState(null);
	// const {authToken,config} = useAuth();
	const { keycloak, initialized } = useKeycloak();
	const kcToken = (keycloak?.token) ?? 'no token';
	const alerts = {
		info:{
			icon:"info-circle",
			color:"gray"
		},
		success:{
			icon:"check",
			color:"#00CC66"
		},
		danger:{
			icon:"times",
			color:"red"
		}
	};

	const info_column = {
		title:"Info",
		key:"info",
		dataIndex:"info",
		render:v =>{
			console.log(v)
			return(
				<FontAwesomeIcon color={alerts[v].color} icon={alerts[v].icon} />
			);
		}

	};



	const dragger_props = {
		name:"csv_file",
		accepts:"text/csv",
		multiple:false,
		action: `${config.api_domain}/csv${!newTemplate?'-old':''}`,
		headers: {
			Authorization: `Bearer ${kcToken}`,
		},
		onChange:(info) =>{
			console.log(info)
			const {status,response} = info.file;
			switch(status){
				case "uploading":
					//do nothing
					break;
				case "done":
					setOriginal(response.data);
					console.log(response.data.data)
					setParsed(response.data.data);
					setStep(1);
					message.success("File uploaded successfully.");
					break;
				case "error":
					message.error("File uploaded failed.");
					break;
				default:
					console.log(info.file, info.fileList);
			}
		}
	};

	const applyTemplate = ()=>{
		console.log(parsed)
		var ds = props.templates[template]().parse(parsed, props.currentProject);
		var columns = props.templates[template]().columns;
		console.log(ds)
		columns = [info_column].concat(columns);
		setColumns(columns);
		setDatasource(ds);
		setStep(2);
	}

	const applyChanges = async ()=>{
		console.log(props)
		setStep(3);
		if (props.currentProject == null) {
			message.info(
				"You must create a project before importing"
			);
			navigate("/dashboard/projects/new")
		} else {
			var output = await props.templates[template]().apply(datasource, axios);
			if(output.error === false){
				message.success("Database updated.");
			}else{
				message.error("Some records could not be updated.");
			}
			var ds = JSON.parse(JSON.stringify(output.datasource));
			setDatasource(ds);
		}
	}

	useEffect(()=>{
		return (()=>{
			Object.values(props.templates).forEach((t)=>{
				if(t.source) t.source.cancel();
			});
		});
	},[]);

	useEffect(()=>{
		if (step === 2) {
			applyTemplate();
		} else if (step === 3) {
			applyChanges();
		}
	},[props.currentProject]);

	// useEffect(() => {
	// 	console.log(template)
	// }, [template]);

	return (
		<>
				<h2>
					CSV Upload
				</h2>
				<h3 style={{paddingTop:"1em"}}>
					<Button 
						shape="circle"  
						type={step === 0 ? "primary" : "secondary"}
					>
					{step === 0 ? 1 : <FontAwesomeIcon icon="check"/>}
					</Button>
					&nbsp;
					File Upload
				</h3>
				<p>Please provide an internal formatted CSV file to start.
					<Switch defaultChecked
							disabled
							value={newTemplate}
							checkedChildren="New Parser"
							unCheckedChildren="Old Parser"
							onChange={setNewTemplate}
					>

					</Switch>
				</p>



				<Dragger {...dragger_props}>
					<p className="ant-upload-drag-icon">
						<InboxOutlined />
					</p>
					<p className="ant-upload-text">
						Click or drag file to this area to upload
					</p>
					<p className="ant-upload-hint">
						Support for a single upload. 
					</p>
				</Dragger>
				{step > 0 && (
					<>
						<h3 style={{paddingTop: "1em"}}>
							<Button
								shape="circle"
								type={step === 0 ? "primary" : "secondary"}
							>
								{step === 1 ? 2 : <FontAwesomeIcon icon="check"/>}
							</Button>
							&nbsp;
							Template Selection
						</h3>
						<p>Please, indicate the format of your file.</p>
						<Select
							value={template}
							onChange={(value) => {
								setTemplate(value)
							}}
							options={Object.keys(props.templates).map((key) => (
								{value: key, label: key}
							))}
						>
						</Select>
						<Button
							type="primary"
							onClick={applyTemplate}
						>
							Select
						</Button>

					</>
				)}
			{step > 1 && (
				<>
					<h3 style={{paddingTop: "1em"}}>
						<Button
							shape="circle"
								type={step === 0 ? "primary" : "secondary"}
							>
								{step === 2 ? 3 : <FontAwesomeIcon icon="check"/>}
							</Button>
							&nbsp;
							Apply changes
						</h3>
						<p>Check parsed information and apply the changes.</p>
						<div style={{overflowX:"auto",width:"100%",height:"fit-content"}}>
							<Table 
								dataSource={datasource} 
								columns={columns}
							/>
						</div>
						<Button
							type="primary"
							onClick={applyChanges}
						>
							Apply
						</Button>	
					</>	
				)}
		</>
	);
}

export default CSVComponent; 
